import React, { useState, useEffect } from 'react';

const AccessibilityToolbar = () => {
  const [fontSize, setFontSize] = useState(16);
  const [toolbarOpen, setToolbarOpen] = useState(false);

 useEffect(() => {
  if (typeof document !== 'undefined') {
    const content = document.getElementById('contents');
    if (content) {
      content.style.fontSize = `${fontSize}px`;
    }
  }
}, [fontSize]);


  const resizeFont = (delta) => {
    setFontSize((prev) => Math.max(prev + delta, 10));
  };

  const toggleClass = (className) => {
    if (typeof document !== 'undefined') {
      if (className === 'underline-links') {
        // Apply underline to all links in the page except the ones in the toolbar
        const links = document.querySelectorAll('a');
        links.forEach((link) => {
          // Check if link is not part of the toolbar before applying underline
          if (!link.closest('#pojo-a11y-toolbar')) {
            link.style.textDecoration = link.style.textDecoration === 'underline' ? '' : 'underline';
          }
        });
      } else {
        const content = document.getElementById('contents');
if (content) {
  content.classList.toggle(className);
}

      }
    }
  };

  return (
    <>
      <style>{`
        .pojo-a11y-toolbar {
          position: fixed;
          bottom: 10px;
          left: 0;
          z-index: 9999;
          transform: translate(-165px);
          transition: all 0.5s ease-in-out;
        }
        .accessibility-open-slide {
          transform: translate(0);
        }
#contents.grayscale,
#contents.negative-contrast,
#contents.light-background {
  overflow: hidden;
}

        .pojo-a11y-toolbar-inner {
          display: flex;
          flex-direction: column;
          gap: 5px;
          background: #fff;
          padding: 4px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
          border-radius: 0 0 5px 0;
        }
		.pojo-a11y-toolbar-inner a:hover {
    color: #385056;
    text-decoration: underline;
}
        .open-Accessibility {
          cursor: pointer;
          position: absolute;
          right: -40px;
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border-radius: 0 5px 5px 0;
          box-shadow: 3px 0 6px rgba(0, 0, 0, 0.1);
        }
        
        .pojo-a11y-toolbar-title {
          margin-bottom: 8px;
        }
        @keyframes rotation {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .pojo-a11y-toolbar-link {
          display: flex;
          align-items: center;
          text-decoration: none;
          font-size: 14px;
          color: #000;
          cursor: pointer;
          border-bottom: 1px solid #eaeaea;
          padding: 4px 0;
        }
        .pojo-a11y-toolbar-link:last-child {
          border: none;
        }
        .pojo-a11y-toolbar-icon {
          margin-right: 8px;
        }
        .grayscale {
          filter: grayscale(100%);
        }
        .high-contrast {
          background-color: #000 !important;
          color: #fff !important;
        }
        .negative-contrast {
          filter: invert(100%);
        }
        .light-background {
          background-color: #f9f9f9 !important;
          color: #000 !important;
        }
      `}</style>

      <nav
        id="pojo-a11y-toolbar"
        className={`pojo-a11y-toolbar ${toolbarOpen ? 'accessibility-open-slide' : ''}`}
        role="navigation"
      >
        <div
          className="open-Accessibility"
          title="Accessibility Tools"
          onClick={() => setToolbarOpen(!toolbarOpen)}
        >
          <span>⚙️</span>
        </div>
        <div className="pojo-a11y-toolbar-inner">
          <p className="pojo-a11y-toolbar-title"><strong>Accessibility Tools</strong></p>
          <a className="pojo-a11y-toolbar-link" onClick={() => resizeFont(1)}>
            <span className="pojo-a11y-toolbar-icon">➕</span><span>Increase Text</span>
          </a>
          <a className="pojo-a11y-toolbar-link" onClick={() => resizeFont(-1)}>
            <span className="pojo-a11y-toolbar-icon">➖</span><span>Decrease Text</span>
          </a>
          <a className="pojo-a11y-toolbar-link" onClick={() => toggleClass('grayscale')}>
            <span className="pojo-a11y-toolbar-icon">🌫️</span><span>Grayscale</span>
          </a>
          <a className="pojo-a11y-toolbar-link" onClick={() => toggleClass('high-contrast')}>
            <span className="pojo-a11y-toolbar-icon">⚪️</span><span>High Contrast</span>
          </a>
          <a className="pojo-a11y-toolbar-link" onClick={() => toggleClass('negative-contrast')}>
            <span className="pojo-a11y-toolbar-icon">🌗</span><span>Negative Contrast</span>
          </a>
          <a className="pojo-a11y-toolbar-link" onClick={() => toggleClass('light-background')}>
            <span className="pojo-a11y-toolbar-icon">🌞</span><span>Light Background</span>
          </a>
          <a className="pojo-a11y-toolbar-link" onClick={() => toggleClass('underline-links')}>
            <span className="pojo-a11y-toolbar-icon">🔗</span><span>Underline Links</span>
          </a>
        </div>
      </nav>
    </>
  );
};

export default AccessibilityToolbar;

